import { Location } from '@core/Router/locations';
import { lazy } from 'react';

const ClinicsPage = lazy(() =>
    import(/* webpackChunkName: "clinics" */ '../ui/ClinicsPage').then(m => ({
        default: m.ClinicsPage,
    })),
);

const clinicsPath = '/clinics';
const clinicPath = '/clinics/:organizationId';

export const clinicsLocations: Location[] = [
    {
        url: clinicsPath,
        Component: ClinicsPage,
    },
    {
        url: clinicPath,
        Component: ClinicsPage,
    },
];
